import { APIService } from '@apparel/core/api';
import { AuthService } from '@apparel/core/auth';
import { Chat } from '@apparel/core/chat';
import { Log } from '@apparel/core/log';
import { PlatformService } from '@apparel/core/platform/PlatformService';
import { WholesalerService } from '@apparel/core/platform/WholesalerService';
import { CartService } from '@apparel/ui/cart';

export async function bootstrap(afterCallback: () => any) {
    Log.configure();

    const logger = Log.channel('Bootstrap');

    await PlatformService.configure();
    const platform = PlatformService.instance.getPlatform();

    await WholesalerService.configure();
    const wholesalerId = WholesalerService.instance.getWholesalerId();

    logger.debug('Configure APIService');
    await APIService.configure({
        platform: platform.toString(),
        wholesaler_id: wholesalerId ? parseInt(wholesalerId) : undefined
    });

    logger.debug('Configure AuthService');
    await AuthService.configure();

    logger.debug('Configure ChatService');
    await Chat.configure({
        platform: platform.company,
    });

    await CartService.configure();

    logger.debug('After bootstrap call');
    await afterCallback();
}
